import { render, staticRenderFns } from "./shareReadingFeeList.vue?vue&type=template&id=5fb3bb10&scoped=true"
import script from "./shareReadingFeeList.vue?vue&type=script&lang=js"
export * from "./shareReadingFeeList.vue?vue&type=script&lang=js"
import style0 from "./shareReadingFeeList.vue?vue&type=style&index=0&id=5fb3bb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb3bb10",
  null
  
)

export default component.exports